import create from 'zustand';

const useStore = create((set) => ({
    activePath: '/',
    setActivePath: (path) => set({activePath: path}),
}));
export default useStore;